import React, { memo } from 'react'
import { DateInput } from 'transfix-ui'

interface IExpirationProps {
  id: string
  label: string
  value?: string
  onChange: (...args: any[]) => any
}

const Expiration: React.FunctionComponent<IExpirationProps> = memo(
  ({ id, label, onChange, value }) => (
    <div className='col-xs-7'>
      <DateInput
        id={id}
        label={label}
        placeholder='mm/dd/yyyy'
        value={value || ''}
        onChange={onChange}
        data-test={id}
      />
    </div>
  )
)

export default Expiration
